import {
  MonaHead as WebGLMonaHead,
  type MonaHeadProps as WebGLMonaHeadProps,
} from '../../../../../brand/components/MonaHead'

import Styles from './MonaHead.module.css'

export interface MonaHeadProps {
  variant: WebGLMonaHeadProps['variant']
  alt?: WebGLMonaHeadProps['alt']
}

export const defaultProps: Partial<MonaHeadProps> = {}

export const MonaHead = (props: MonaHeadProps) => {
  const initializedProps: MonaHeadProps = {...defaultProps, ...props}

  return (
    <div className={Styles['MonaHead']}>
      <svg className={Styles['MonaHead__particles']} viewBox="0 0 209 144" aria-hidden="true" focusable="false">
        <path className={Styles['MonaHead__particle']} d="M0 20h10v10H0z" />
        <path className={Styles['MonaHead__particle']} d="M30 30h10v10H30z" />
        <path className={Styles['MonaHead__particle']} d="M20 40h10v10H20z" />
        <path className={Styles['MonaHead__particle']} d="M169 30h10v10h-10z" />
        <path className={Styles['MonaHead__particle']} d="M179 40h10v10h-10z" />
        <path className={Styles['MonaHead__particle']} d="M199 20h10v10h-10z" />
      </svg>
      <div className={Styles['MonaHead__artwork']}>
        <WebGLMonaHead {...initializedProps} />
      </div>
    </div>
  )
}
